import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=0f4e4e79&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=0f4e4e79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports